// axios.js
import axios from 'axios'
import * as sabitler from '../sabitler'
import Cookies from 'js-cookie'
import {
    useAuthStore
} from '@/stores/auth'
import {
    TenantService
} from './../config/tenant'

const instance = axios.create({
    baseURL: sabitler.apiBaseURL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
})

// Request interceptor
instance.interceptors.request.use(
    config => {
        const accessToken = Cookies.get('accessToken')

        // Debug için
        //console.log('Current token:', accessToken)

        if (accessToken) {
            // Bearer token'ı ekle
            config.headers.Authorization = `Bearer ${accessToken}`

            // Debug için
            //console.log('Authorization header:', config.headers.Authorization)
        }

        // Tenant header'ı
        config.headers['X-Tenant'] = TenantService.getCurrentTenant()
        return config
    },
    error => Promise.reject(error)
)

// Response interceptor
instance.interceptors.response.use(
    response => response,
    async error => {
        // Token expired durumu
        if (error.response?.status === 401 && !error.config._retry) {
            error.config._retry = true

            const authStore = useAuthStore()
            const refreshSuccess = await authStore.refreshTokens()

            if (refreshSuccess) {
                const accessToken = Cookies.get('accessToken')
                error.config.headers.Authorization = `Bearer ${accessToken}`
                return instance(error.config)
            }

            authStore.logout()
        }

        return Promise.reject(error)
    }
)

// Aşağıdaki özellik  multipart/form-data özelliğini eklemek için kullanıldı.
// const apiMultipartRequest = async <T>( useApi.ts ye bak
instance.postWithConfig = async (url, data, config) => {
    return instance.post(url, data, config)
}

// PATCH için multipart desteği ekle
instance.patchWithConfig = async (url, data, config) => {
    return instance.patch(url, data, config)
}


export default instance